import { render, staticRenderFns } from "./2DMPRManager.vue?vue&type=template&id=51c8401e&scoped=true&"
import script from "./2DMPRManager.vue?vue&type=script&lang=js&"
export * from "./2DMPRManager.vue?vue&type=script&lang=js&"
import style0 from "./2DMPRManager.vue?vue&type=style&index=0&id=51c8401e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8401e",
  null
  
)

export default component.exports